// Product Features Component
if (!customElements.get('product-features-component')) {
  class ProductFeaturesComponent extends HTMLElement {
    /** @type {NodeListOf<HTMLElement>} */
    items;
    /** @type {NodeListOf<HTMLElement>} */
    images;
    
    constructor() {
      super();
      this.items = this.querySelectorAll('.js-product-features-item');
      this.images = this.querySelectorAll('.js-product-features-image');
      this.init();
    }

    init() {
      this.setupEventListeners();
      // Set initial active states
      if (this.items.length > 0) {
        this.setActiveItem(/** @type {HTMLElement} */ (this.items[0]));
      }
    }

    setupEventListeners() {
      this.items.forEach((item) => {
        item.addEventListener('click', () => this.handleItemClick(item));
      });
    }

    /**
     * Handle click on an accordion item
     * @param {HTMLElement} clickedItem - The item that was clicked
     */
    handleItemClick(clickedItem) {
      // Update accordion items
      this.items.forEach((item) => {
        if (item === clickedItem) {
          item.classList.add('--is-active');
        } else {
          item.classList.remove('--is-active');
        }
      });

      // Update images
      this.setActiveImage(clickedItem.getAttribute('data-feature-item'));
    }

    /**
     * Set an item as active
     * @param {HTMLElement} item - The item to activate
     */
    setActiveItem(item) {
      item.classList.add('--is-active');
      this.setActiveImage(item.getAttribute('data-feature-item'));
    }

    /**
     * Set the corresponding image as active
     * @param {string|null} featureItemId - The ID of the feature item
     */
    setActiveImage(featureItemId) {
      this.images.forEach((image) => {
        if (image.getAttribute('data-feature-item') === featureItemId) {
          image.classList.add('--is-active');
        } else {
          image.classList.remove('--is-active');
        }
      });
    }
  }

  customElements.define('product-features-component', ProductFeaturesComponent);
}